import { GET_RINGTONES_QUERY } from '../../graphql/queries/GetRingtonesQuery';
import { useGraphQuery } from '../useQuery/useGraphQuery';

import { GetRingtonesQuery, GetRingtonesQuery_getRingtones } from '@generated/GetRingtonesQuery';

/**
 * Fetch a list of ringtone and return it
 */
export function useRingtones(): GetRingtonesQuery_getRingtones[] | undefined {
  const { data } = useGraphQuery<GetRingtonesQuery>(GET_RINGTONES_QUERY);
  return data?.getRingtones;
}
